export const hasChangedIgnoringNullish = (a: any, b: any): boolean =>
    !(a == null && b == null) && a !== b;
